"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.reducers = exports.initialState = void 0;
var _reducerMap7 = _interopRequireDefault(require("../redux/reducerMap"));
var _actions = require("./actions");
var _reducerMap, _reducerMap2, _reducerMap3, _reducerMap4, _reducerMap5, _reducerMap6; // import { List, Map, fromJS } from '../immutable'
var initialState = exports.initialState = {
  wishlist: [],
  viewedProducts: [],
  onboardingResult: {},
  kitchenConfigurations: {},
  resetNotificationsAt: new Date(0).toISOString(),
  sharedStateAge: {
    timestamp: new Date(0).toISOString(),
    source: null
  }
};
var wishlistReducer = (0, _reducerMap7.default)((_reducerMap = {}, _reducerMap[_actions.actionTypes.ADD_WISHLIST] = function (state, action) {
  return state.map(function (product) {
    return product.id;
  }).includes(action.product.id) ? state : [].concat(state, [action.product]);
}, _reducerMap[_actions.actionTypes.REMOVE_WISHLIST] = function (state, action) {
  return state.map(function (product) {
    return product.id;
  }).includes(action.productId) ? state.filter(function (product) {
    return product.id !== action.productId;
  }) : state;
}, _reducerMap[_actions.actionTypes.CLEAR_WISHLIST] = function () {
  return [];
}, _reducerMap), initialState.wishlist);
var viewedProductsReducer = (0, _reducerMap7.default)((_reducerMap2 = {}, _reducerMap2[_actions.actionTypes.VIEW_PRODUCT] = function (state, action) {
  return [action.product].concat(state.filter(function (product) {
    return product.id !== action.product.id;
  })).slice(0, 7);
}, _reducerMap2), initialState.viewedProducts);
var onboardingResultReducer = (0, _reducerMap7.default)((_reducerMap3 = {}, _reducerMap3[_actions.actionTypes.SET_ONBOARDING_RESULT] = function (state, action) {
  return action.result;
}, _reducerMap3[_actions.actionTypes.CLEAR_ONBOARDING_RESULT] = function () {
  return {};
}, _reducerMap3), initialState.onboardingResult);
var kitchenConfigurationsReducer = (0, _reducerMap7.default)((_reducerMap4 = {}, _reducerMap4[_actions.actionTypes.ADD_KITCHEN_CONFIGURATION] = function (state, action) {
  var _Object$assign3;
  var kitchenRangeName = action.kitchenRangeName,
    config = action.config;
  if (!kitchenRangeName || !config) return state;
  var configurationNumber = parseInt(config.configurationNumber, 10);
  var newConfig = Object.assign({}, config, {
    configurationNumber: configurationNumber || 1,
    createdAt: new Date().toISOString()
  });
  if (state[kitchenRangeName]) {
    var _Object$assign2;
    var kitchenRange = state[kitchenRangeName];
    var existingConfigurationIds = kitchenRange.map(function (c) {
      return c.configurationNumber;
    });
    var configurationNumberIndex = kitchenRange.findIndex(function (item) {
      return item.configurationNumber === configurationNumber;
    });
    if (configurationNumberIndex === -1) {
      var _Object$assign;
      var newNumber = Math.max.apply(Math, existingConfigurationIds) + 1;
      var newConfigIncremented = Object.assign({}, newConfig, {
        configurationNumber: newNumber
      });
      return Object.assign({}, state, (_Object$assign = {}, _Object$assign[kitchenRangeName] = [].concat(kitchenRange, [newConfigIncremented]), _Object$assign));
    }
    return Object.assign({}, state, (_Object$assign2 = {}, _Object$assign2[kitchenRangeName] = kitchenRange.map(function (currentConfig, i) {
      return i === configurationNumberIndex ? newConfig : currentConfig;
    }), _Object$assign2));
  }
  return Object.assign({}, state, (_Object$assign3 = {}, _Object$assign3[kitchenRangeName] = [newConfig], _Object$assign3));
}, _reducerMap4[_actions.actionTypes.CLEAR_KITCHEN_CONFIGURATIONS] = function () {
  return {};
}, _reducerMap4), initialState.kitchenConfigurations);
var notificationReducer = (0, _reducerMap7.default)((_reducerMap5 = {}, _reducerMap5[_actions.actionTypes.RESET_NOTIFICATIONS] = function () {
  return new Date().toISOString();
}, _reducerMap5), initialState.resetNotificationsAt);
var sharedStateAgeReducer = (0, _reducerMap7.default)((_reducerMap6 = {}, _reducerMap6[_actions.actionTypes.UPDATED_SHARED_STATE] = function (state, action) {
  return {
    source: action.source,
    timestamp: new Date().toISOString()
  };
}, _reducerMap6), initialState.sharedStateAge);
var reducers = exports.reducers = {
  wishlist: wishlistReducer,
  viewedProducts: viewedProductsReducer,
  onboardingResult: onboardingResultReducer,
  kitchenConfigurations: kitchenConfigurationsReducer,
  resetNotificationsAt: notificationReducer,
  sharedStateAge: sharedStateAgeReducer
};